module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone_selected.43c3229d.svg";